import { Injectable } from '@angular/core';

@Injectable()
export class DatesService {
  public dateFormatForCalendar: string = 'mm/dd/yy';

  constructor() {
  }
}
